import { Box } from '@mantine/core'
import { FieldRenderer } from './FieldRenderer'
import { SectionCard } from '../layout/SectionCard'
import classes from '../../styles/StudioEditorV2.module.css'

const wideTypes = new Set([
  'segmented',
  'image',
  'image-editor',
  'focal-point',
  'rich-text',
  'textarea',
  'string-list',
  'contact-list',
])

export function SchemaSection({
  section,
  templateManifest,
  configuration,
  errors,
  updateValue,
  addAsset,
  addRenditionPreview,
  assetUrls,
  assetSourceUrls,
}) {
  return (
    <SectionCard title={section.label} description={section.description}>
      <div className={classes.fieldGrid}>
        {(section.fields || []).map((field) => (
          <Box
            key={field.path}
            className={wideTypes.has(field.type) ? classes.fullField : undefined}
          >
            <FieldRenderer
              field={field}
              templateManifest={templateManifest}
              configuration={configuration}
              error={errors[field.path]}
              onChange={updateValue}
              addAsset={addAsset}
              addRenditionPreview={addRenditionPreview}
              assetUrls={assetUrls}
              assetSourceUrls={assetSourceUrls}
            />
          </Box>
        ))}
      </div>
    </SectionCard>
  )
}
